function Contacts() {
  return (
    
    <div className="">
       <p>раздел в разработке</p>
    </div>
  );
}

export default Contacts;